import { render, staticRenderFns } from "./folder-item.vue?vue&type=template&id=7ca0a2d0"
import script from "./folder-item.vue?vue&type=script&lang=js"
export * from "./folder-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports